import { Box, Paper, Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import React, { useEffect, useState } from "react";
import useAcumulado from "../../../hooks/useAcumulado.jsx";
import SelectAnio from "../select/SelectAnio.jsx";
import SelectTrimestre from "../select/SelectTrimestre.jsx";

const GraficoLoading = () => (
  <div className="flex justify-center items-center h-64">
    <p className="text-gray-500">Cargando gráfico...</p>
  </div>
);

const GraficoError = ({ error }) => (
  <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
    <strong className="font-bold">¡Error!</strong>
    <span className="block sm:inline">No se pudieron cargar los datos del gráfico.</span>
    <p className="text-sm mt-2">{error.message}</p>
  </div>
);

const ChartAcumulado = () => {
  const [year, setYear] = useState(new Date().getFullYear());
  const [quarter, setQuarter] = useState("all");
  const { data, loading, error, refetch } = useAcumulado({ year, quarter });

  useEffect(() => {
    async function fetchData() {
      await refetch({ year, quarter });
    }
    fetchData();
  }, [year, quarter, refetch]);

  if (loading) {
    return <GraficoLoading />;
  }
  if (!loading && error) {
    return <GraficoError error={error} />;
  }
  if (!loading && !error && data) {
    const xLabels = Object.keys(data.acumulado);
    const charValues = Object.values(data.acumulado);

    return (
      <Paper
        variant="outlined"
        sx={{ p: 3, borderColor: "grey.200" }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={3}
        >
          <Typography variant="h6" component="h2" fontWeight="bold">
            Acumulado por tipo de alcohol
          </Typography>

          {/* Contenedor de Selects */}
          <Box display="flex" gap={1.5}>
            {/* 'gap' añade espacio entre los selects */}
            <SelectAnio value={year} setValue={setYear} />
            <SelectTrimestre value={quarter} setValue={setQuarter} />
          </Box>
        </Box>
        <Box sx={{ height: 350, width: "100%" }}>
          <BarChart
            // --- Eje X ---
            xAxis={[
              {
                data: xLabels,
                scaleType: "band", // 'band' es para datos categóricos (días)
                grid: { display: false }, // Oculta la cuadrícula vertical
              },
            ]}
            // --- Eje Y ---
            yAxis={[
              {
                grid: { display: true }, // Muestra la cuadrícula horizontal
              },
            ]}
            // --- Datos (Series) ---
            series={[
              {
                data: charValues,
                color: "#6497b1",
                borderRadius: 4,
              },
            ]}
            // Oculta la leyenda
            legend={{ hidden: true }}
          />
        </Box>
      </Paper>
    );
  }
};

export default ChartAcumulado;
